import { apiClient } from './axios';

export interface SignatureRequest {
  id: string;
  documenso_document_id: number | null;
  title: string;
  recipient_name: string;
  recipient_email: string;
  message: string | null;
  signing_url: string | null;
  status: 'CREATED' | 'SENT' | 'OPENED' | 'COMPLETED' | 'REJECTED' | 'FAILED' | 'CANCELLED';
  error_message: string | null;
  webhook_payload: Record<string, unknown> | null;
  sent_at: string | null;
  opened_at: string | null;
  completed_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface PaginatedResponse<T> {
  data: T[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

interface SignatureRequestsQuery {
  status?: string;
  page?: number;
  limit?: number;
}

export interface PendingSignatureSummary {
  id: string;
  title: string;
  signing_url: string | null;
  sent_at: string | null;
}

export interface PendingSignatures {
  count: number;
  items: PendingSignatureSummary[];
}

export const signaturesApi = {
  getSignatureRequests: async (
    query?: SignatureRequestsQuery,
  ): Promise<PaginatedResponse<SignatureRequest>> => {
    const response = await apiClient.get<PaginatedResponse<SignatureRequest>>('/signatures', {
      params: query,
    });
    return response.data;
  },

  getPendingCount: async (): Promise<PendingSignatures> => {
    const response = await apiClient.get<PendingSignatures>('/signatures/pending-count');
    return response.data;
  },

  getDownloadUrl: async (id: string): Promise<{ downloadUrl: string }> => {
    const response = await apiClient.get<{ downloadUrl: string }>(`/signatures/${id}/download-url`);
    return response.data;
  },
};
